/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/adjacent-overload-signatures */
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IChoice, IProductOption, StorePageStore } from '@boxx/store-core';
import {
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-variant-creator',
  templateUrl: './variant-creator.page.html',
  styleUrls: ['./variant-creator.page.scss'],
})
export class VariantCreatorPage implements OnInit, OnDestroy {
  destroyed$ = new Subject<boolean>();
  loader: HTMLIonLoadingElement;
  translations: any;

  variationForm: FormGroup;
  public previousProductOptions: IProductOption[];
  productOptions: IProductOption[];
  choiseOption: IChoice;

  constructor(
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private fb: FormBuilder,
    private storePageStore: StorePageStore,
    private translate: TranslateService
  ) {
    this.translate
      .get(['STORE', 'ERRORS', 'SUCCESS'])
      .pipe(takeUntil(this.destroyed$))
      .subscribe((t: any) => (this.translations = t));
  }

  get optionsForm() {
    return this.variationForm.controls.options as any;
  }

  onFieldChange() {

  }

  // onTypeChange(id){
  //     const type = this.variationForm.value;
  //     if(type.entryType === 'TEXTFIELD' || type.entryType === 'TEXTAREA' || type.entryType === 'DATE'){
  //       //this.productOptions = [];
  //     }
  // }

  // addOption(){
  // // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  // const control = <FormArray>this.optionsForm.controls;
  //     control.push(this.initForm());
  // }

  // initForm(): FormGroup
  // {
  //    return this.fb.group({
  //     title: ['', Validators.required],
  //           entryType: ['SELECT', Validators.required],
  //           required: [false, Validators.required],
  //           optionName: [''],
  //           options: new FormArray([]),
  //    });
  // }

  // saveProductOptions(){

  // }


  onTypeChange(id) {
    const type = this.productOptions.filter(item => item.id === id);
    if (type[0].type === 'TEXTFIELD' || type[0].type === 'TEXTAREA' || type[0].type === 'DATE') {
      //this.productOptions = [];
    }
  }

  addOption() {
    const newId = new Date().valueOf();

    this.productOptions.push({
      id: newId,
      type: 'SELECT',
      name: '',
      nameTranslated: {
        es_419: '',
      },
      defaultChoice: 0,
      required: false,
      choices: [],
    });

  }




  ngOnInit() {

    this.productOptions = [];
    this.handleLoading();
    this.handleSuccess();
    this.handleError();

    if (this.previousProductOptions.length > 0) {
      this.previousProductOptions.forEach(item => {
        const nameTranslated = '';
        // if(item.choices && item.choices.length > 0){
        //   item.choices.forEach(choice => {
        //     if(choice.textTranslated && choice.textTranslated.es_419){
        //       nameTranslated = choice.textTranslated.es_419;
        //     }
        //   });
        // }

        const arrayChoice = [];
        if(item.choices && item.choices.length > 0){
          item.choices.forEach(choice => {
            arrayChoice.push({
              text: choice.text,
              typeChoice: (Math.sign(choice.priceModifier) === 1) ? '1' : '0',
              textTranslated: {
                es_419: (choice.textTranslated.es_419) ? choice.textTranslated.es_419 : '',
              },
              priceModifier: choice.priceModifier,
              priceModifierType: choice.priceModifierType
            });
          });
        }

        this.productOptions.push({
          id: new Date().valueOf(),
          type: item.type,
          name: item.name,
          nameTranslated: {
            es_419: (nameTranslated) ? nameTranslated : '',
          },
          defaultChoice: item.defaultChoice,
          required: (item.required) ? item.required : false,
          choices: (arrayChoice.length > 0) ? arrayChoice : []
        });

      });
    }

    this.variationForm = this.fb.group({
      title: ['', Validators.required],
      entryType: ['SELECT', Validators.required],
      required: [false, Validators.required],
      optionName: [''],
      options: new FormArray([]),
    });

    //this.addOptionField();
  }

  saveProductOptions() {
    if (this.productOptions.length > 0) {
      this.productOptions.forEach(option => {
        option.nameTranslated.es_419 = option.name;

        if(option.choices && option.choices.length > 0){
          // eslint-disable-next-line @typescript-eslint/prefer-for-of
          for(let i = 0; i < option.choices.length; i++){
            option.choices[i].priceModifier = Number(option.choices[i].priceModifier);
            option.choices[i].textTranslated.es_419 = option.choices[i].text;
          }
        }


      });
    }
    this.modalCtrl.dismiss(this.productOptions);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  handleLoading() {
    this.storePageStore.variationsStore.loading$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (loading) => {

        if (loading) {
          if (!this.loader) {
            this.loader = await this.loadingCtrl.create();
          }

          this.loader.present();
        } else {
          if (this.loader) {
            await this.loadingCtrl.dismiss();
          } else {
            setTimeout(async () => {
              if (this.loader) {
                await this.loadingCtrl.dismiss();
              }
            }, 800);
          }

          this.loader = undefined;
        }
      });
  }

  handleSuccess() {
    this.storePageStore.variationsStore.success$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (success) => {
        if (success && success.after === 'CREATE_VARIATION') {
          const toast = await this.toastController.create({
            message:
              this.translations.SUCCESS.STORE.VARIANTS[
              success.after.toLowerCase()
              ],
            duration: 3000,
            color: 'success',
          });
          toast.present();

          setTimeout(() => {
            this.modalCtrl.dismiss();
          }, 1000);
        }
      });
  }

  handleError() {
    this.storePageStore.variationsStore.error$
      .pipe(takeUntil(this.destroyed$))
      .subscribe(async (error) => {
        if (error) {
          const toast = await this.toastController.create({
            message:
              this.translations.ERRORS.STORE.VARIANTS[
              error.after.toLowerCase()
              ],
            duration: 5000,
            color: 'danger',
          });
          toast.present();
        }
      });
  }

  cancel() {
    this.modalCtrl.dismiss();
  }

  create() {
    const options = [];

    (this.variationForm.controls.options.value as Array<any>).forEach((opt) => {
      options.push([opt.optionName, opt.optionPrice]);
    });

    const payload = {
      name: this.variationForm.controls.name.value,
      required: this.variationForm.controls.required.value,
      options,
    };

    // this.storePageStore.variationsStore.createVariation(payload);
  }

  // addOptionField(val: string = '') {
  //   // this.optionsForm.push(
  //   //   this.fb.group({
  //   //     optionName: [val, Validators.required],
  //   //     optionPrice: [val, Validators.required],
  //   //   })
  //   // );
  // }

  async removeOptionField(idx: number) {
    if (this.optionsForm.controls.length === 1) {
      const toast = await this.toastController.create({
        message: this.translations.STORE.VARIANTS.WARN.keepOneOption,
        duration: 3000,
        color: 'warning',
      });
      toast.present();
      return;
    }
    this.optionsForm.removeAt(idx);
  }

  addChoice(id) {
    const newChoice: IChoice = {
      typeChoice: '1',
      text: '',
      textTranslated: {
        es_419: ''
      },
      priceModifier: 0,
      priceModifierType: 'ABSOLUTE',
    };
    const option = this.productOptions.filter(item => item.id === id);
    option[0].choices.push(newChoice);
  }

  deleteOption(index) {
    this.productOptions.splice(index, 1);
  }

  deleteChoice(id, index) {
    const option = this.productOptions.filter(item => item.id === id);
    option[0].choices.splice(index, 1);
  }
}
